<div class="search-box">
  <select [formControl]="searchType">
    <option value="1">BUSCA POR CNPJ</option>
    <option value="2">BUSCA POR RAZÃO SOCIAL</option>
  </select>
  <input
    #inputValue
    *ngIf="searchType.value == 1"
    [(ngModel)]="filterText"
    placeholder="01.234.567/0001-00"
    [textMask]="{
      mask: fiscalNumberMask,
      guide: false,
      keepCharPositions: true
    }"
    (keypress)="onPressEnterSearchCompanies($event)" />
  <input #inputValue *ngIf="searchType.value == 2" [(ngModel)]="filterText" placeholder="Razão Social" (keypress)="onPressEnterSearchCompanies($event)" />
  <div class="search-icon-container" (click)="searchCompanies(filterText)">
    <mat-icon aria-hidden="false">search</mat-icon>
  </div>
</div>
<diV class="company-card-container">
  <div class="search-control">
    <p *ngIf="pageableResult.getItems().length > 1">{{ pageableResult.getItems().length }} RESULTADOS ENCONTRADOS</p>
    <p *ngIf="pageableResult.getItems().length == 1">1 RESULTADO ENCONTRADO</p>
    <p *ngIf="pageableResult.getItems().length == 0">Nenhum resultado encontrado.</p>
    <div class="scroll-text" *ngIf="showScrollBottomBtn()" (click)="scrollToLastCompany()">
      <mat-icon aria-hidden="false">arrow_drop_down</mat-icon>
      <span class="btn-title">ir para o fim da lista</span>
    </div>
  </div>

  <div *ngFor="let company of getCompanyList()">
    <div class="company-card">
      <div class="company-data">
        <p class="company-name">{{ company.getCorporateName() }}</p>
        <span class="company-cnpj"> CNPJ: {{ company.getFiscalNumber() | companyFederalNumber }} </span>
        <span class="company-description">Razão social: {{ company.getTradingName() }}</span>
      </div>
      <div *ngIf="hasAccessToViewFinancialStatement()" class="company-status">
        <div class="view-btn" (click)="navigateToFinancialStatementCompany(company.getFiscalNumber())">
          <mat-icon aria-hidden="false">visibility</mat-icon>
          <span>{{ "VISUALIZAR" }}</span>
        </div>
      </div>
    </div>
  </div>

  <a class="more-companies-btn" *ngIf="showMoreCompaniesBtn()" (click)="searchMoreCompanies()">carregar mais registros</a>
  <div id="bottom"></div>
</diV>
